import { ROUTE_NAME } from "@/constants/constants";

export const HO_SO_CONG_VIEC_FIELD = {
  KY_HIEU: "KyHieu",
  TIEU_DE: "TieuDe",
  NOI_DUNG: "NoiDung",
  NGAY_MO_HO_SO: "NgayMoHoSo",
  HAN_XU_LY: "HanXuLy",
  DON_VI_LAP_HO_SO: "DonViTao",
  NGUOI_LAP_HO_SO: "NguoiTao",
  TRANG_THAI_XU_LY: "TrangThai",
  FILE: "FileDinhKems",
  HO_SO_QUAN_TRONG: "IsHoSoQuanTrong",
  TRANG_THAI_HIEU_LUC: "TrangThaiHieuLuc",
  SO_NGAY: "SoNgay",
  VAI_TRO: "VaiTro",
  MA_HO_SO: "MaHoSo",
  // TRANG_THAI_CAP_NHAT_LUONG: "TrangThaiCapNhatLuong",
  THONG_TIN_TRA_LAI: "ThongTinTraLai",
};

export const COT_HO_SO_CONG_VIEC_BAN_DAU = [
 // HO_SO_CONG_VIEC_FIELD.KY_HIEU,
  HO_SO_CONG_VIEC_FIELD.TIEU_DE,
  HO_SO_CONG_VIEC_FIELD.NOI_DUNG,
  HO_SO_CONG_VIEC_FIELD.NGAY_MO_HO_SO,
  HO_SO_CONG_VIEC_FIELD.HAN_XU_LY,
  HO_SO_CONG_VIEC_FIELD.MA_HO_SO,
  HO_SO_CONG_VIEC_FIELD.VAI_TRO,
  HO_SO_CONG_VIEC_FIELD.DON_VI_LAP_HO_SO,
  HO_SO_CONG_VIEC_FIELD.NGUOI_LAP_HO_SO,
  HO_SO_CONG_VIEC_FIELD.TRANG_THAI_XU_LY,
  HO_SO_CONG_VIEC_FIELD.FILE,
];

export const HO_SO_CONG_VIEC_FORM = {
  KyHieuFilter: "",
  TieuDeFilter: "",
  NoiDungFilter: "",
  YKienXuLyMoiFilter: "",
  NgayTaoStartFilter: null,
  NgayTaoEndFilter: null,
  HanXuLyStartFilter: null,
  HanXuLyEndFilter: null,
  KeySearch: "",
  IsHoSoQuanTrongFilter: null,
  TrangThaiXuLyFilter: null,
  TrangThaiHieuLucFilter: null,
  TrangThaiHoSoCongViecVoiTaiKhoanDangNhapFilter: null,
  //TrangThaiCapNhatLuongFilter: null,
  VaiTroFilter: null,
  MaHoSoFilter: "",
};

export const MANG_HO_SO_CONG_VIEC_FIELDS = [
  {
    field: HO_SO_CONG_VIEC_FIELD.FILE,
    header: "File",
    bodyClass: "text-center",
    headerClass: "text-center",
    classColunm: "width: auto; min-width: 20px",
    // keySearch: "FileNameFilter",
  },
  {
    field: HO_SO_CONG_VIEC_FIELD.KY_HIEU,
    header: "Ký hiệu",
    bodyClass: "text-left",
    keySearch: "KyHieuFilter",
  },
  {
    field: HO_SO_CONG_VIEC_FIELD.TIEU_DE,
    header: "Tiêu đề hồ sơ",
    bodyClass: "text-left",
    keySearch: "TieuDeFilter",
    classColunm: "minWidth: 200px",
  },
  {
    field: HO_SO_CONG_VIEC_FIELD.NOI_DUNG,
    header: "Nội dung hồ sơ",
    bodyClass: "text-left",
    keySearch: "NoiDungFilter",
    classColunm: "minWidth: 200px",
  },
  {
    field: HO_SO_CONG_VIEC_FIELD.NGAY_MO_HO_SO,
    header: "Ngày mở hồ sơ",
    bodyClass: "text-center",
  },
  {
    field: HO_SO_CONG_VIEC_FIELD.VAI_TRO,
    header: "Vai trò",
    bodyClass: "text-left",
    classColunm: "width: auto; min-width: 100px",
  },
  {
    field: HO_SO_CONG_VIEC_FIELD.HAN_XU_LY,
    header: "Hạn xử lý",
    bodyClass: "text-center",
  },
  {
    field: HO_SO_CONG_VIEC_FIELD.DON_VI_LAP_HO_SO,
    header: "Đơn vị lập hồ sơ",
    bodyClass: "text-left",
    keySearch: "DonViTaoFilter",
  },
  {
    field: HO_SO_CONG_VIEC_FIELD.NGUOI_LAP_HO_SO,
    header: "Người lập hồ sơ",
    bodyClass: "text-left",
    keySearch: "NguoiTaoFilter",
  },
  {
    field: HO_SO_CONG_VIEC_FIELD.TRANG_THAI_XU_LY,
    header: "Trạng thái xử lý",
    bodyClass: "text-center",
    exportField: "TrangThaiXuLy",
    classColunm: "width: auto; min-width: 100px",
  },
  {
    field: HO_SO_CONG_VIEC_FIELD.HO_SO_QUAN_TRONG,
    header: "Hồ sơ quan trọng",
    bodyClass: "text-center",
  },
  {
    field: HO_SO_CONG_VIEC_FIELD.TRANG_THAI_HIEU_LUC,
    header: "Trạng thái hiệu lực hồ sơ quan trọng",
    bodyClass: "text-center",
    classColunm: "minWidth: 100px",
  },
  {
    field: HO_SO_CONG_VIEC_FIELD.SO_NGAY,
    header: "Số ngày",
    bodyClass: "text-right",
  },
  {
    field: HO_SO_CONG_VIEC_FIELD.THONG_TIN_TRA_LAI,
    header: "Thông tin trả lại",
    keySearch: "NoiDungTraLaiFilter",
    bodyClass: "text-left",
  },
];

export const TRANG_THAI_HO_SO_CONG_VIEC = {
  CHO_PHAN_XU_LY: 1,
  CHUA_XU_LY: 2,
  DANG_XU_LY: 3,
  DA_KET_THUC: 4,
  DA_TRA_LAI: 5,
  BI_TRA_LAI: 6,
  BI_THU_HOI: 7,
  CHO_CHO_Y_KIEN: 8,
  DA_CHO_Y_KIEN: 9,
};

export const MANG_LOC_TRANG_THAI = [
  {
    text: "Tất cả",
    value: null,
  },
  {
    text: "Chờ duyệt và phân xử lý",
    value: TRANG_THAI_HO_SO_CONG_VIEC.CHO_PHAN_XU_LY,
  },
  {
    text: "Chờ xử lý",
    value: TRANG_THAI_HO_SO_CONG_VIEC.CHUA_XU_LY,
  },
  {
    text: "Đang xử lý",
    value: TRANG_THAI_HO_SO_CONG_VIEC.DANG_XU_LY,
  },
  {
    text: "Đã hoàn thành",
    value: TRANG_THAI_HO_SO_CONG_VIEC.DA_HOAN_THANH,
  },
];

export const TRANG_THAI_XU_LY_CONG_VIEC = {
  QUA_HAN: 1,
  DEN_HAN: 2,
  TRONG_HAN: 3,
};

export const MANG_LOC_TRANG_THAI_XU_LY = [
  {
    text: "Tất cả",
    value: null,
  },
  {
    text: "Quá hạn",
    value: TRANG_THAI_XU_LY_CONG_VIEC.QUA_HAN,
  },
  {
    text: "Đến hạn",
    value: TRANG_THAI_XU_LY_CONG_VIEC.DEN_HAN,
  },
  {
    text: "Trong hạn",
    value: TRANG_THAI_XU_LY_CONG_VIEC.TRONG_HAN,
  },
];

export const SO_LUONG_HSCV = {
  BI_THU_HOI: "SoLuongBiThuHoi",
  BI_TRA_LAI: "SoLuongBiTraLai",
  CHO_PHAN_XU_LY: "SoLuongChoPhanXuLy",
  CHO_XU_LY: "SoLuongChoXuLy",
  DA_KET_THUC: "SoLuongDaKetThuc",
  DA_TRA_LAI: "SoLuongDaTraLai",
  DANG_XU_LY: "SoLuongDangXuLy",
  CHO_CHO_Y_KIEN: "SoLuongChoChoYKien",
  DA_CHO_Y_KIEN: "SoLuongDaChoYKien",
};

export const COT_VAN_BAN_DI_BAN_DAU_QLDS = [
  HO_SO_CONG_VIEC_FIELD.SO_DI,
  HO_SO_CONG_VIEC_FIELD.SO_VAN_BAN,
  HO_SO_CONG_VIEC_FIELD.LOAI_VAN_BAN,
  HO_SO_CONG_VIEC_FIELD.SO_KY_HIEU,
  HO_SO_CONG_VIEC_FIELD.TRICH_YEU,
];

export const CF_MODAL_TYPE = {
  TRINH_KY: 1,
  HUY_TRINH_KY: 2,
  DUYET: 3,
  HUY_DUYET: 4,
  KY_SO_FILE: 5,
  BAN_HANH: 6,
  XOA: 7,
  ADD_QR_CODE: 8,
};

export const TRANG_THAI_HIEU_LUC_HSQT = {
  KHI_DONG_LUONG: 1,
  THEO_NGAY: 2,
};

export const MANG_TRANG_THAI_HIEU_LUC_HSQT = [
  {
    value: TRANG_THAI_HIEU_LUC_HSQT.KHI_DONG_LUONG,
    text: "Khi đóng luồng",
  },
  {
    value: TRANG_THAI_HIEU_LUC_HSQT.THEO_NGAY,
    text: "Theo ngày",
  },
];

export const MANG_VAN_BAN_FIELDS = [
  {
    field: "Stt",
    header: "STT",
    bodyClass: "text-center",
    headerClass: "w-5 bg-header",
  },
  {
    field: "SoKyHieu",
    header: "Số/Ký hiệu",
    bodyClass: "text-left",
    headerClass: "w-10 bg-header",
  },
  {
    field: "Files",
    header: "Tệp đính kèm",
    bodyClass: "text-center",
    headerClass: "w-20 bg-header",
  },
  {
    field: "TrichYeu",
    header: "Trích yếu",
    headerClass: "w-20 bg-header",
  },
  {
    field: "IsVanBanDen",
    header: "Loại văn bản",
    bodyClass: "text-left",
    headerClass: "w-10 bg-header",
  },
  {
    field: "HoTen",
    header: "Người bổ sung",
    headerClass: "w-15 bg-header",
  },
  {
    field: "Xoa",
    header: "Xóa",
    headerClass: "w-5 bg-header",
  },
];
export const MANG_FILE_HS_FIELDS = [
  {
    field: "Stt",
    header: "STT",
    bodyClass: "text-center",
    headerClass: "w-10",
  },
  {
    field: "Xoa",
    header: "Thao Tác",
    headerClass: "w-10",
    bodyClass: "text-center",
  },
  {
    field: "Ten",
    header: "Tên file",
    bodyClass: "text-center",
    headerClass: "w-50",
  },
  {
    field: "NguoiTao",
    header: "Người thêm",
    bodyClass: "text-center",
    headerClass: "w-30",
  },
];
export const MANG_FILE_VB_FIELDS = [
  {
    field: "Stt",
    header: "STT",
    bodyClass: "text-center",
    headerClass: "w-10 bg-header",
  },
  {
    field: "Ten",
    header: "Tên file",
    bodyClass: "text-left",
    headerClass: "w-40 bg-header",
  },
  {
    field: "NguoiTao",
    header: "Người bổ sung",
    bodyClass: "text-left",
    headerClass: "w-30 bg-header",
  },
  {
    field: "KySo",
    header: "Ký số",
    headerClass: "w-10 bg-header",
    bodyClass: "text-center",
  },
  {
    field: "Xoa",
    header: "Xóa",
    headerClass: "w-10 bg-header",
    bodyClass: "text-center",
  },
];

export const ACTION_TYPE = {
  THEM_MOI: 1,
  XEM: 2,
  SUA: 3,
};

export const MANG_LICH_SU_CAP_NHAT_TINH_HINH_THUC_HIEN = [
  {
    key: "Stt",
    label: "STT",
  },
  {
    key: "TenCanBo",
    label: "Người cập nhật",
  },
  {
    key: "TenDonVi",
    label: "Đơn vị cập nhật",
  },
  {
    key: "ThoiGian",
    label: "Thời gian",
  },
  {
    key: "NoiDung",
    label: "Nội dung cập nhật",
    class: "word-break",
  },
  {
    key: "HanhDong",
    label: "Hành động",
  },
  {
    key: "File",
    label: "File đính kèm",
  },
];

export const MANG_LICH_SU_TRA_LAI = [
  {
    key: "Stt",
    label: "STT",
  },
  {
    key: "NguoiTraLai",
    label: "Người trả lại",
  },
  {
    key: "DonViTraLai",
    label: "Đơn vị trả lại",
  },
  {
    key: "NguoiBiTraLai",
    label: "Người bị trả lại",
  },
  {
    key: "DonViBiTraLai",
    label: "Đơn vị bị trả lại",
  },
  {
    key: "ThoiGian",
    label: "Thời gian",
  },
  {
    key: "NoiDung",
    label: "Nội dung",
    class: "word-break",
  },
];

export const MANG_LICH_SU_THU_HOI = [
  {
    key: "NguoiThuHoi",
    label: "Người thu hồi",
  },
  {
    key: "DonViThuHoi",
    label: "Đơn vị thu hồi",
  },
  {
    key: "NguoiBiThuHoi",
    label: "Người bị thu hồi",
  },
  {
    key: "DonViBiThuHoi",
    label: "Đơn vị bị thu hồi",
  },
  {
    key: "ThoiGian",
    label: "Thời gian",
  },
  {
    key: "NoiDung",
    label: "Nội dung",
  },
  {
    key: "File",
    label: "File đính kèm",
  },
];

export const MANG_LICH_SU_PXL_FIELDS = [
  {
    field: "Stt",
    header: "STT",
    bodyClass: "text-center",
    headerClass: "w-5",
  },
  {
    field: "TenCanBoPhanXuLy",
    header: "Người gửi",
    headerClass: "w-15",
    keySearch: "NguoiGui",
  },
  {
    field: "TenCanBoDuocPhanXuLy",
    header: "Người nhận",
    headerClass: "w-15",
    keySearch: "NguoiNhan",
  },
  {
    field: "TenDonViDuocPhanXuLy",
    header: "Đơn vị nhận",
    headerClass: "w-20",
    keySearch: "DonViNhan",
  },
  {
    field: "ActionPhanXuLy",
    header: "Thao tác",
    headerClass: "w-15",
    keySearchs: "ActionPhanXuLy",
  },
  {
    field: "VaiTro",
    header: "Vai trò xử lý",
    bodyClass: "text-left",
    headerClass: "w-15",
    keySearchs: "VaiTroPhanXuLy",
  },
  {
    field: "NgayTao",
    header: "Thời gian",
    bodyClass: "text-center",
    headerClass: "w-25",
  },
];

export const MANG_TAI_LIEU_HSLT = [
  {
    field: "MaHoSo",
    header: "Mã hồ sơ",
    headerClass: "w-15",
    keySearch: "MaHoSo",
  },
  {
    field: "TieuDeHoSo",
    header: "Tiêu đề",
    headerClass: "w-40",
    keySearch: "TieuDeHoSo",
  },
  {
    field: "TenDeMuc",
    header: "Đề mục",
    headerClass: "w-40",
    keySearch: "TenDeMuc",
  },
  {
    field: "NamThucHien",
    header: "Năm",
    headerClass: "w-15",
  },
  {
    field: "NgayMoHoSo",
    header: "Ngày mở",
    headerClass: "w-20",
  },
  {
    field: "NgayCapNhatGanNhat",
    header: "Ngày cập nhật",
    headerClass: "w-20",
  },
  {
    field: "TenNguoiLapHoSo",
    header: "Người lập",
    headerClass: "w-20",
    keySearch: "TenNguoiLapHoSo",
  },
  {
    field: "TrangThai",
    header: "Trạng thái",
    headerClass: "w-20",
  },
];
export const TRANG_THAI_HSCV_MENU = {
  TRA_CUU: 0,
  CHO_PHAN_XU_LY: 1,
  CHO_XU_LY: 2,
  DANG_XU_LY: 3,
  DA_HOAN_THANH: 4,
  DA_TRA_LAI: 5,
  BI_TRA_LAI: 6,
  BI_THU_HOI: 7,
  NHAN_DE_BIET: 8,
  CHO_CHO_Y_KIEN: 9,
  DA_CHO_Y_KIEN: 10,
};

export const MANG_TRANG_THAI_HSCV_MENU = [
  {
    value: TRANG_THAI_HSCV_MENU.TRA_CUU,
    text: ROUTE_NAME.HO_SO_CONG_VIEC.TRA_CUU,
  },
  {
    value: TRANG_THAI_HSCV_MENU.CHO_PHAN_XU_LY,
    text: ROUTE_NAME.HO_SO_CONG_VIEC.CHO_PHAN_XU_LY,
  },
  {
    value: TRANG_THAI_HSCV_MENU.CHO_XU_LY,
    text: ROUTE_NAME.HO_SO_CONG_VIEC.CHO_XU_LY,
  },
  {
    value: TRANG_THAI_HSCV_MENU.DANG_XU_LY,
    text: ROUTE_NAME.HO_SO_CONG_VIEC.DANG_THUC_HIEN,
  },
  {
    value: TRANG_THAI_HSCV_MENU.DA_HOAN_THANH,
    text: ROUTE_NAME.HO_SO_CONG_VIEC.DA_KET_THUC,
  },
  {
    value: TRANG_THAI_HSCV_MENU.DA_TRA_LAI,
    text: ROUTE_NAME.HO_SO_CONG_VIEC.DA_TRA_LAI,
  },
  {
    value: TRANG_THAI_HSCV_MENU.BI_TRA_LAI,
    text: ROUTE_NAME.HO_SO_CONG_VIEC.BI_TRA_LAI,
  },
  {
    value: TRANG_THAI_HSCV_MENU.BI_THU_HOI,
    text: ROUTE_NAME.HO_SO_CONG_VIEC.DA_BI_THU_HOI,
  },
  {
    value: TRANG_THAI_HSCV_MENU.NHAN_DE_BIET,
    text: ROUTE_NAME.HO_SO_CONG_VIEC.NHAN_DE_BIET,
  },
  {
    value: TRANG_THAI_HSCV_MENU.CHO_CHO_Y_KIEN,
    text: ROUTE_NAME.HO_SO_CONG_VIEC.CHO_CHO_Y_KIEN,
  },
  {
    value: TRANG_THAI_HSCV_MENU.DA_CHO_Y_KIEN,
    text: ROUTE_NAME.HO_SO_CONG_VIEC.DA_CHO_Y_KIEN,
  },
];

export const HANH_DONG_CAP_NHAT = [
  {
    id: null,
    name: "Tất cả",
  },
  {
    id: 1,
    name: "Phân xử lý",
  },
  {
    id: 2,
    name: "Trả lại",
  },
  {
    id: 3,
    name: "Thu hồi",
    noFilter: true,
  },
  {
    id: 4,
    name: "Xóa khỏi phân xử lý",
  },
  {
    id: 5,
    name: "Cập nhật vai trò của phân xử lý",
  },
  {
    id: 6,
    name: "Kết thúc hồ sơ",
    noFilter: true,
  },
  {
    id: 7,
    name: "Mở lại hồ sơ",
    noFilter: true,
  },
  {
    id: 8,
    name: "Tạo mới hồ sơ",
    noFilter: true,
  },
  {
    id: 9,
    name: "Cập nhật hồ sơ",
    noFilter: true,
  },
  {
    id: 10,
    name: "Duyệt hồ sơ",
    noFilter: true,
  },
  {
    id: 11,
    name: "Hủy duyệt hồ sơ",
    noFilter: true,
  },
  {
    id: 12,
    name: "Cập nhật văn bản hồ sơ",
    noFilter: true,
  },
];

export const XEM_LICH_SU_HEADER_TAB = [
  {
    title: "Lịch sử cập nhật",
    header: MANG_LICH_SU_CAP_NHAT_TINH_HINH_THUC_HIEN,
    list: [],
  },
  {
    title: "Lịch sử trả lại",
    header: MANG_LICH_SU_TRA_LAI,
    list: [],
  },
];

export const GIA_TRI_VAI_TRO_XU_LY = {
  LANH_DAO_GIAO_VIEC: 4,
  GIAO_VIEC_CAP_1: 5,
  LANH_DAO_THEO_DOI: 6,
  XU_LY_CHINH: 7,
  PHOI_HOP_XU_LY: 8,
  THEO_DOI: 9,
  NGUOI_TAO: 10,
};

export const MANG_VAI_TRO_XU_LY = [
  {
    value: null,
    text: "Chọn vai trò xử lý",
  },
  {
    value: GIA_TRI_VAI_TRO_XU_LY.LANH_DAO_GIAO_VIEC,
    text: "Lãnh đạo giao việc",
  },
  {
    value: GIA_TRI_VAI_TRO_XU_LY.GIAO_VIEC_CAP_1,
    text: "Giao việc cấp 1",
  },
  {
    value: GIA_TRI_VAI_TRO_XU_LY.LANH_DAO_THEO_DOI,
    text: "Lãnh đạo theo dõi",
  },
  {
    value: GIA_TRI_VAI_TRO_XU_LY.XU_LY_CHINH,
    text: "Xử lý chính",
  },
  {
    value: GIA_TRI_VAI_TRO_XU_LY.PHOI_HOP_XU_LY,
    text: "Phối hợp xử lý",
  },
  {
    value: GIA_TRI_VAI_TRO_XU_LY.THEO_DOI,
    text: "Theo dõi",
  },
];

export const MANG_VAI_TRO = [
  {
    value: null,
    text: "Tất cả",
  },
  {
    value: 4,
    text: "Lãnh đạo giao việc",
  },
  {
    value: 5,
    text: "Giao việc cấp 1",
  },
  {
    value: 6,
    text: "Lãnh đạo theo dõi",
  },
  {
    value: 7,
    text: "Xử lý chính",
  },
  {
    value: 8,
    text: "Phối hợp xử lý",
  },
  {
    value: 9,
    text: "Theo dõi",
  },
  {
    value: 10,
    text: "Người tạo",
  },
];

export const MANG_VAI_TRO_XU_LY_TREE = [
  {
    value: GIA_TRI_VAI_TRO_XU_LY.LANH_DAO_GIAO_VIEC,
    text: "Lãnh đạo giao việc",
  },
  {
    value: GIA_TRI_VAI_TRO_XU_LY.GIAO_VIEC_CAP_1,
    text: "Giao việc cấp 1",
  },
  {
    value: GIA_TRI_VAI_TRO_XU_LY.LANH_DAO_THEO_DOI,
    text: "Lãnh đạo theo dõi",
  },
  {
    value: GIA_TRI_VAI_TRO_XU_LY.XU_LY_CHINH,
    text: "Xử lý chính",
  },
  {
    value: GIA_TRI_VAI_TRO_XU_LY.PHOI_HOP_XU_LY,
    text: "Phối hợp xử lý",
  },
  {
    value: GIA_TRI_VAI_TRO_XU_LY.THEO_DOI,
    text: "Theo dõi",
  },
  {
    value: GIA_TRI_VAI_TRO_XU_LY.NGUOI_TAO,
    text: "Người tạo",
  },
];

export const LOAI_DU_LIEU_THOI_GIAN = {
  TAT_CA: null,
  TUAN: 1,
  THANG: 2,
  NAM: 3,
};

export const MANG_LOAI_THOI_GIAN = [
  {
    text: "Tất cả",
    value: LOAI_DU_LIEU_THOI_GIAN.TAT_CA,
  },
  {
    text: "Tuần này",
    value: LOAI_DU_LIEU_THOI_GIAN.TUAN,
  },
  {
    text: "Tháng này",
    value: LOAI_DU_LIEU_THOI_GIAN.THANG,
  },
  {
    text: "Năm nay",
    value: LOAI_DU_LIEU_THOI_GIAN.NAM,
  },
];

export const VALUE_TREE_HSCV_PXL = {
  DON_VI: 0,
  TAT_CA_DON_VI: 1,
  LANH_DAO_VA_VAN_THU: 2,
};

export const OPTION_LOAI_DANH_SACH_HSCV_PXL = [
  { text: "Đơn vị", value: VALUE_TREE_HSCV_PXL.DON_VI },
  { text: "Các đơn vị", value: VALUE_TREE_HSCV_PXL.TAT_CA_DON_VI },
  {
    text: "Thủ trưởng, văn thư các đơn vị",
    value: VALUE_TREE_HSCV_PXL.LANH_DAO_VA_VAN_THU,
  },
];

export const VALUE_HSCV_PXL = {
  PHAN_CAP: 0,
  TUY_CHON: 1,
};

export const OPTION_LOAI_PXL_HSCV = [
  { text: "Phân cấp", value: VALUE_HSCV_PXL.PHAN_CAP },
  { text: "Tùy chọn", value: VALUE_HSCV_PXL.TUY_CHON },
];

export function closeIfNotFound(message, vm) {
  if ((message || "").toLowerCase().includes("bản ghi không tồn tại")) {
    vm.$router.push({
      path: ROUTE_NAME.HO_SO_CONG_VIEC.NAME + vm.$route.params.route,
    });
  }
}
